// Event detail page slugs, kept apart from the page data so the router can register the
// routes without pulling every page's content into the main bundle.
// The data file uses `satisfies Record<EventSlug, ...>`, so the two lists cannot drift apart.
export const EVENT_SLUGS = [
'iks-guest-lecture',
  'guest-lecture-workshop-on-nematology',
  'monsoon-fest',
  'propel',
  'farewell-party',
  'freshers-party',
  'karwaan-2026',
  'ganesh-utsav',
  'shiv-jayanti',
  'diwali-milan',
  'garba-celebration',
  'orientation-programme',
  'entrepreneurship-club',
  'farmers-training-programme',
  'innovation-in-education',
  'startup-setu-26',
  'womens-day',
  'financial-analytics-academic-entrepreneurship',
  'national-law-fest',
  'india-israei-hackathon',
  'guest-lecture-event',
  'republic-2026-day',
  'international-youth',
  'spell-bee-competition',
  'aac-camp',
  'international-fide-chess',
  'cricket-box-leagus',
  'training-programme-on-recent-advances-extraction',
  'dance-workshop',
  'ccll-nptel',
  'open-house-parents-meeting',
  'fusion-chinese-feast',
  'yoga',
  'l-and-d-program',
  'agrimechanica',
  'expert-session',
  'ai-creation-challenge',
  'international-conference-ayush',
  'national-pharmacist-day',
  '7th-convocation-ceremony',
  'e-convocation-ceremony',
  'national-symposium',
  'campus-recuritment-traning-program',
  'microgreens-production',
  'cadits-night-farewell-party',
  'induction-program',
  'startup-pitch',
  'central-library',
] as const;

export type EventSlug = (typeof EVENT_SLUGS)[number];
